import { FiThumbsUp, FiThumbsDown, FiStar, FiAlertTriangle, FiHelpCircle } from 'react-icons/fi';
import React from 'react';
import SummaryCard from './SummaryCard';


function SummarySection({ executiveSummary }) {
    const getIndicatorIcon = (indicator) => {
        switch (indicator.toLowerCase()) {
            case 'good':
                return <FiStar className="text-green-500" />;
            case 'bad':
                return <FiThumbsDown className="text-red-500" />;
            case 'ok':
                return <FiThumbsUp className="text-green-500" />;
            case 'immediate_attention':
                return <FiAlertTriangle className="text-red-600 animate-pulse" />;
            default:
                return <FiHelpCircle className="text-gray-400" />;
        }
    };

    return (
        <SummaryCard title="Summary">
            <div className="mb-4">
                <p className="content-text text-gray-600 leading-relaxed">
                    This financial health report provides a detailed analysis of your current financial standing, highlighting key strengths and areas for improvement. It includes recommendations to help you achieve your financial goals.
                </p>
            </div>

            <div className="space-y-2">
                {executiveSummary.key_findings && executiveSummary.key_findings.map((keyFinding, index) => (
                    <div key={index} className="flex items-start p-4 rounded-lg bg-white border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200">
                        <div className="flex-shrink-0 mr-3 mt-1">
                            {getIndicatorIcon(keyFinding.indicator)}
                        </div>
                        <div className="flex-1">
                            <p className="content-text text-gray-700 leading-relaxed font-medium mb-0">
                                {keyFinding.finding}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </SummaryCard>
    );
}

export default SummarySection;
